import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { SLICE_NAME } from "src/_cores/_enums/state.enum";
import { ILoaderState } from "src/_cores/_interfaces/state.interface";

const initialState: ILoaderState = {
  isApiLoading: 0,
};

const loaderSlice = createSlice({
  name: SLICE_NAME.LOADER,
  initialState: initialState,
  reducers: {
    show: (state) => {
      state.isApiLoading += 1;
    },
    hide: (state) => {
      state.isApiLoading = Math.max(0, state.isApiLoading - 1);
    },
  },
});

export const { show, hide } =
  loaderSlice.actions;

const loaderReducer = loaderSlice.reducer;
export default loaderReducer;
